/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorFixAvailableQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorFixAvailableQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorFixAvailableQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorFixAvailableQueryOperator>): InfraVulnerabilityAWSInspectorFixAvailableQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorFixAvailableQueryOperator(), model);
        InfraVulnerabilityAWSInspectorFixAvailableQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorFixAvailableQueryOperator>): InfraVulnerabilityAWSInspectorFixAvailableQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorFixAvailableQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorFixAvailableQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorFixAvailableQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorFixAvailableQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorFixAvailableQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorFixAvailableQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Fix availability status(es) to include - AWS Inspector reports YES, NO, or PARTIAL (some but not all affected packages have a fix)
     */
    fix_available: Array<models.InfraVulnerabilityAWSInspectorFixAvailable>;

}
